(() => {
  const modal = document.querySelector('[data-everwest-disclaimer]');
  if (!modal) return;

  const checkbox = modal.querySelector('[data-everwest-disclaimer-accept]');
  const error = modal.querySelector('[data-everwest-disclaimer-error]');
  const confirmButton = modal.querySelector('[data-everwest-disclaimer-confirm]');
  let pendingCheckoutControl = null;
  let checkoutApproved = false;

  const closeModal = () => {
    if (modal.open) modal.close();
    pendingCheckoutControl = null;
    error.hidden = true;
  };

  modal.querySelectorAll('[data-everwest-disclaimer-close]').forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  checkbox.addEventListener('change', () => {
    if (checkbox.checked) error.hidden = true;
  });

  confirmButton.addEventListener('click', () => {
    if (!checkbox.checked) {
      error.hidden = false;
      checkbox.focus();
      return;
    }

    const checkoutControl = pendingCheckoutControl;
    checkoutApproved = true;
    closeModal();

    if (checkoutControl?.tagName === 'A') {
      window.location.assign(checkoutControl.href);
      return;
    }

    const form = checkoutControl?.form || checkoutControl?.closest?.('form');
    if (form) {
      form.requestSubmit(checkoutControl);
    } else {
      window.location.assign('/checkout');
    }
  });

  document.addEventListener('click', (event) => {
    const checkoutControl = event.target.closest(
      '[name="checkout"], [name="goto_pp"], [name="goto_gc"], a[href*="/checkout"]'
    );
    if (!checkoutControl || checkoutApproved) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingCheckoutControl = checkoutControl;
    checkbox.checked = false;
    error.hidden = true;
    modal.showModal();
  }, true);
})();
